'use strict';

import React from 'react';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';

import constants from 'constants/appConstants';
import _ from 'underscore';

const propTypes = {
    
};

const defaultProps = {
    
};

class TextArea extends React.Component {

    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.focusHandler = this.focusHandler.bind(this);
        this.blurHandler = this.blurHandler.bind(this);
        this.state = {};
    }

    changeValue(event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();            
        this.props.setValue(event.currentTarget.value);
        if (this.props.onChangeCallback) {
            if (typeof(this.props.onChangeCallback) === "function") {
                this.props.onChangeCallback(event);
            } else if (typeof(this.props.onChangeCallback) === "object") {
                _.each(this.props.onChangeCallback, function (fn, i) {
                    fn(event);
                });
            }
        }
    }

    focusHandler(event) {
        if (this.props.onFocusCallback) {
            if (typeof(this.props.onFocusCallback) === "function") {
                this.props.onFocusCallback(event);
            } else if (typeof(this.props.onFocusCallback) === "object") {
                _.each(this.props.onFocusCallback, function (fn, i) {
                    fn(event);
                });
            }
        }
    }

    blurHandler(event) {
        if (this.props.onBlurCallback) {
            if (typeof(this.props.onBlurCallback) === "function") {
                this.props.onBlurCallback(event);
            } else if (typeof(this.props.onBlurCallback) === "object") {
                _.each(this.props.onBlurCallback, function (fn, i) {
                    fn(event);
                });
            }
        }
    }

    render() {
        var classes = classNames(
            'fc-input', this.props.className, {
                'required': this.props.showRequired() && !this.props.isPristine(),
                'error': !(this.props.showRequired() && !this.props.isPristine()) && this.props.showError(),
                'server-error': this.props.serverMessage,
                'disabled': this.props.disabled,
            }
        );

        var inputClasses = classNames(
            {
                used: this.props.getValue(),
            }
        );

        var requiredElement;
        if (this.props.isRequired()) {
            requiredElement = <span className="required-msg validation-error">{constants.error.FORMS.FORM_FIELD_REQUIRED}</span>;            
        }

        return (
            <div id={'form-element-{0}'.format(this.props.name)} className={classes}>
                <textarea
                    className={inputClasses}
                    id={this.props.name}
                    name={this.props.name}
                    type={this.props.type || "text"}
                    onChange={this.changeValue}
                    onFocus={this.focusHandler}
                    onBlur={this.blurHandler}
                    maxLength={this.props.maxLength}
                    value={this.props.getValue() || ''}
                    autoComplete={this.props.autocomplete || "on"}
                    ref={this.props.name}
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder}
                />
                <label htmlFor={this.props.name}>{this.props.label}</label>
                <span className="validation-error">{this.props.getErrorMessage()}</span>
                <span className="server-error-msg validation-error">{this.props.serverMessage}</span>
                {requiredElement}
            </div>
        );
    }
}

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;
export default withFormsy(TextArea); 